// Imports => Constants
import { ENDPOINTS } from '@constants';

export class BankAccountsAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }

  list = (params = {}) => {
    return this.Client.get(ENDPOINTS.BANK_ACCOUNTS.LIST, { params }).then(
      (response) => response.data.data
    );
  };
}

export default BankAccountsAPI;
